<template>
  <v-overlay color="primary" opacity="1" style="z-index: 100">
    <div
      class="d-flex flex-column align-center"
      style="z-index: 100; position: relative"
    >
      <!-- <lottie
        :options="defaultOptions"
        :height="500"
        :width="500"
        :animCreated="handleAnimation"
      /> -->
      <!-- <img
        src="@/assets/logo.png"
        alt=""
        style="
          width: 170px;
          height: 55px;
          position: absolute;
          left: 50%;
          margin-left: -50px;
          top: 50%;
          margin-top: -50px;
        "
        class="mb-10"
      /> -->
    </div>
  </v-overlay>
</template>

<script>
import Lottie from "vue-lottie";
// import animationData from "@/assets/animation-loader.json";
export default {
  components: {
    // lottie: Lottie,
  },
  created() {},

  data() {
    return {
      // defaultOptions: { animationData: animationData, animationSpeed: 0.9 },
      animationSpeed: 0.3,
    };
  },

  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
  },
};
</script>

<style scoped lang="scss">
</style>